module.exports = __webpack_public_path__ + "static/img/logo@2x.507e42c0.png";